import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8e6c19b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "lcts-tooltip" }
const _hoisted_2 = { class: "lcts-tooltip-header" }
const _hoisted_3 = { class: "lcts-tooltip-header-title" }
const _hoisted_4 = { class: "card-tag-container" }
const _hoisted_5 = {
  key: 0,
  class: "card-tag"
}
const _hoisted_6 = { class: "card-tag__content" }
const _hoisted_7 = {
  class: "card-tag__right",
  ref: "firstCardRef"
}
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { class: "lcts-tooltip-header" }
const _hoisted_10 = { class: "lcts-tooltip-info" }
const _hoisted_11 = { class: "lcts-tooltip-container" }
const _hoisted_12 = { class: "lcts-tooltip-label" }
const _hoisted_13 = { class: "lcts-tooltip-value" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "lcts-tooltip-content tooltip bs-tooltip-auto",
      style: _normalizeStyle({ transform: _ctx.position })
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h3", _hoisted_3, _toDisplayString(_ctx.title), 1),
        _createElementVNode("div", _hoisted_4, [
          (_ctx.tagValue)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                  _createElementVNode("div", {
                    class: "card-tag__left",
                    style: _normalizeStyle('background:' + _ctx.tagColor + ';')
                  }, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.tagLabel), 1)
                  ], 4),
                  _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(_ctx.tagValue), 1)
                  ], 512)
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _hoisted_8,
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("h3", null, _toDisplayString(_ctx.title2), 1)
      ]),
      _createElementVNode("div", _hoisted_10, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tooltipData, (item, key) => {
          return (_openBlock(), _createElementBlock("div", { key: key }, [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("p", _hoisted_12, _toDisplayString(key) + ":", 1),
              _createElementVNode("p", _hoisted_13, _toDisplayString(item), 1)
            ])
          ]))
        }), 128))
      ])
    ], 4)
  ]))
}